export const LOAD_SECURITY_ALERTS_FOR_LAST_MONTH = "LOAD_SECURITY_ALERTS_FOR_LAST_MONTH";
export const LOAD_SECURITY_ALERTS_LAST_MONTH_SUCCESS = "LOAD_SECURITY_ALERTS_LAST_MONTH_SUCCESS";
export const LOAD_SECIURITY_ALERTS_LAST_MONTH_FAILED = "LOAD_SECIURITY_ALERTS_LAST_MONTH_FAILED";

export const LOAD_SECURITY_ALERTS_LAST_WEEK_SUCCESS = "LOAD_SECURITY_ALERTS_LAST_WEEK_SUCCESS";
export const LOAD_SECURITY_ALERTS_LAST_WEEK = "LOAD_SECURITY_ALERTS_LAST_WEEK";
export const LOAD_SECURITY_ALERTS_FOR_LAST_WEEK_FAILED = "LOAD_SECURITY_ALERTS_FOR_LAST_WEEK_FAILED";

export const LOAD_INCIDENTS_SUCCESS = "LOAD_INCIDENTS_SUCCESS";
export const LOAD_INCIDENTS = "LOAD_INCIDENTS";
export const LOAD_INCIDENTS_FAILED = "LOAD_INCIDENTS_FAILED";

export const LOAD_SYSTEM_STATUS_SUCCESS = "LOAD_SYSTEM_STATUS_SUCCESS";
export const LOAD_SYSTEM_STATUS = "LOAD_SYSTEM_STATUS";
export const LOAD_SYSTEM_STATUS_FAILED = "LOAD_SYSTEM_STATUS_FAILED";

export const LOAD_LOGS_PER_DAY_SUCCESS = "LOAD_LOGS_PER_DAY_SUCCESS";
export const LOAD_LOGS_PER_DAY = "LOAD_LOGS_PER_DAY";
export const LOAD_LOGS_PER_DAY_FAILED = "LOAD_LOGS_PER_DAY_FAILED";

export const LOAD_DEVICE_GROUPS = "LOAD_DEVICE_GROUPS";
export const LOAD_DEVICE_GROUPS_SUCCESS = "LOAD_DEVICE_GROUPS_SUCCESS";
export const LOAD_DEVICE_GROUPS_FAILED = "LOAD_DEVICE_GROUPS_FAILED";


// WEBPACK FOOTER //
// ./src/dashboard/dashboardActionTypes.js